module.exports = __webpack_public_path__ + "static/media/airplane.1422a882.svg";